import logo from '../data/ziyara.png';
import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const HOME_SCROLL_THRESHOLD_PX = 48;

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [homeScrolled, setHomeScrolled] = useState(false);
  const location = useLocation();
  const isAgenciesPage = location.pathname === '/agences' || location.pathname === '/';
  const isHomeMarketplace = location.pathname === '/home';
  const heroCollapsed = isHomeMarketplace && !homeScrolled;

  useEffect(() => {
    if (!isHomeMarketplace) return;
    const onScroll = () => setHomeScrolled(window.scrollY > HOME_SCROLL_THRESHOLD_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isHomeMarketplace]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 pt-[env(safe-area-inset-top)] transition-[background-color,box-shadow,backdrop-filter] duration-300 ease-out ${
        heroCollapsed
          ? 'bg-transparent shadow-none'
          : 'bg-white/95 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {heroCollapsed ? (
          <div className="relative flex items-center justify-start py-7 md:py-8">
            <Link to="/" className="flex shrink-0 items-center">
              <img
                src={logo}
                alt="Ziyara Travel Logo"
                className="h-28 w-auto drop-shadow-md transition-transform duration-300 sm:h-32 md:h-36"
              />
            </Link>
            <button
              type="button"
              className="absolute right-0 top-1/2 -translate-y-1/2 rounded-lg p-2 text-white hover:bg-white/10 md:hidden"
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        ) : (
          <div className="flex justify-between h-20 items-center">
            <Link to="/" className="flex items-center">
              <img
                src={logo}
                alt="Ziyara Travel Logo"
                className="h-20 w-auto"
              />
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              {!isAgenciesPage && (
                <>
                  <Link to="/agences" className="text-gray-700 hover:text-blue-600 transition">
                    Nos Agences
                  </Link>
                  <a href="#destinations" className="text-gray-700 hover:text-blue-600 transition">
                    Destinations
                  </a>
                  <Link to="/offres" className="text-gray-700 hover:text-blue-600 transition">
                    Séjours
                  </Link>
                  <Link to="/pricing" className="hidden text-gray-700 hover:text-blue-600 transition">
                    Tarifs
                  </Link>
                </>
              )}
              <Link
                to="/login"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Espace agence
              </Link>
            </div>

            <button
              type="button"
              className="md:hidden text-gray-700 p-2 rounded-lg hover:bg-gray-100"
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            >
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        )}
      </div>

      {/* Menu mobile */}
      {isOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {!isAgenciesPage && (
              <>
                <Link
                  to="/agences"
                  className="block px-3 py-2 text-gray-700 hover:text-blue-600"
                  onClick={() => setIsOpen(false)}
                >
                  Nos Agences
                </Link>
                <a href="#destinations" className="block px-3 py-2 text-gray-700 hover:text-blue-600">
                  Destinations
                </a>
                <Link
                  to="/offres"
                  className="block px-3 py-2 text-gray-700 hover:text-blue-600"
                  onClick={() => setIsOpen(false)}
                >
                  Séjours
                </Link>
                <Link to="/pricing" className="hidden">
                  Tarifs
                </Link>
              </>
            )}
            <Link
              to="/login"
              className="block px-3 py-2 text-gray-700 hover:text-blue-600"
              onClick={() => setIsOpen(false)}
            >
              Espace agence
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}